// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"46928a87ce6dd78f","3675":"f54ca52c3573402b","4831":"f54ca52c3573402b"}[chunkId] + ".css";
};